import { ThemeConfig } from 'antd';
import colors from 'tailwindcss/colors';

const defaultTheme: ThemeConfig = {
  token: {
    colorPrimary: '#0AB187',
    colorBorder: colors.gray[200],
    fontFamily: 'var(--font-display)',
    fontSize: 16,
    borderRadius: 6,
    lineWidth: 2,
    controlHeight: 44
  },

  components: {
    Form: {
      verticalLabelPadding: '0 0 3px',
      itemMarginBottom: 16,
      labelColor: colors.gray[600]
    },

    Input: {
      paddingInline: 16,
      paddingInlineSM: 12,
      colorTextPlaceholder: colors.gray[400],
      colorText: colors.black,
      fontSizeLG: 16,
      borderRadiusSM: 6,
      activeShadow: 'none'
    },

    Select: {
      colorTextPlaceholder: colors.gray[400],
      colorText: colors.black,
      fontSizeLG: 16,
      optionPadding: 8,
      optionHeight: 20
    },

    Button: {
      fontFamily: 'var(--font-display)',
      defaultShadow: 'none',
      primaryShadow: 'none',
      paddingInlineSM: 12,
      paddingInline: 16,
      fontSize: 16,
      borderRadiusSM: 6
    },

    Dropdown: {
      fontSize: 16,
      fontFamily: 'DM Sans'
    },

    Checkbox: {
      colorText: colors.gray[600]
    },

    Modal: {
      controlHeight: 32
    },

    Alert: {
      fontSizeIcon: 10
    },

    Message: {
      contentPadding: '8px 12px'
    }
  }
};

export default defaultTheme;
